$wj([51],{

/***/ 2264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var addFolderIdToMoveToMruList_1 = __webpack_require__(4733);
exports.addFolderIdToMoveToMruList = addFolderIdToMoveToMruList_1.default;
var removeFolderIdFromMoveToMruList_1 = __webpack_require__(4736);
exports.removeFolderIdFromMoveToMruList = removeFolderIdFromMoveToMruList_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 3669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var targetFolderMruConfiguration_1 = __webpack_require__(3670);
var targetFolderMRUEntry_1 = __webpack_require__(4734);
var setFolderMruConfigurationOperation_1 = __webpack_require__(4735);
/**
 * Action to set folder Mru Configuration
 * @param folderMruEntries - list of folder mru entries to save to server
 */
function setFolderMruConfigurationService(folderMruEntries) {
    var targetFolderIds = folderMruEntries.map(function (id) {
        return targetFolderMRUEntry_1.default({ EwsFolderIdEntry: id });
    });
    var mruConfiguration = targetFolderMruConfiguration_1.default({ FolderMruEntries: targetFolderIds });
    return setFolderMruConfigurationOperation_1.default({
        folderMruConfiguration: mruConfiguration,
    }).then(function (response) {
        return response;
    });
}
exports.default = setFolderMruConfigurationService;
//# sourceMappingURL=setFolderMruConfigurationService.js.map

/***/ }),

/***/ 3670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function targetFolderMruConfiguration(data) {
    var result = tslib_1.__assign({ __type: 'TargetFolderMruConfiguration:#Exchange' }, data);
    return result;
}
exports.default = targetFolderMruConfiguration;


/***/ }),

/***/ 4733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setFolderMruConfigurationService_1 = __webpack_require__(3669);
var store_1 = __webpack_require__(1711);
var legacy_1 = __webpack_require__(1);
var MAX_MRU_FOLDER_COUNT = 10;
/**
 * Action to add a folderId to Mru list and save it to server
 * @param folderId - folderIs to add to mru list
 */
exports.default = legacy_1.action('addFolderIdToMoveToMruList')(function addFolderIdToMoveToMruList(folderId) {
    updateFolderMruList(folderId);
    var store = store_1.getStore();
    if (store.isInitialized) {
        setFolderMruConfigurationService_1.default(store.mruFolders);
    }
});
function updateFolderMruList(folderId) {
    var store = store_1.getStore();
    var index = store.mruFolders.indexOf(folderId);
    if (index >= 0) {
        // Move the folderId to front if it already exists in the list
        store.mruFolders.splice(index, 1);
        store.mruFolders.unshift(folderId);
    }
    else {
        // Add folderId to front of the list and trim the list
        store.mruFolders.unshift(folderId);
        store.mruFolders.splice(MAX_MRU_FOLDER_COUNT);
    }
}
//# sourceMappingURL=addFolderIdToMoveToMruList.js.map

/***/ }),

/***/ 4734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function targetFolderMRUEntry(data) {
    var result = tslib_1.__assign({ __type: 'TargetFolderMRUEntry:#Exchange' }, data);
    return result;
}
exports.default = targetFolderMRUEntry;


/***/ }),

/***/ 4735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var targetFolderMruConfiguration_1 = __webpack_require__(3670);
function setFolderMruConfigurationOperation(req, options) {
    if (req.folderMruConfiguration !== undefined && !req.folderMruConfiguration["__type"]) {
        req.folderMruConfiguration = targetFolderMruConfiguration_1.default(req.folderMruConfiguration);
    }
    return ServiceRequest_1.makeServiceRequest("SetFolderMruConfiguration", req, options);
}
exports.default = setFolderMruConfigurationOperation;


/***/ }),

/***/ 4736:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setFolderMruConfigurationService_1 = __webpack_require__(3669);
var store_1 = __webpack_require__(1711);
var legacy_1 = __webpack_require__(1);
/**
 * Action to remove a folderId fromn Mru list and save it to server
 * @param folderId - folderIs to remove from mru list
 */
exports.default = legacy_1.action('removeFolderIdFromMoveToMruList')(function removeFolderIdFromMoveToMruList(folderId) {
    var mruStore = store_1.getStore();
    var index = mruStore.mruFolders.indexOf(folderId);
    if (index < 0) {
        return;
    }
    mruStore.mruFolders.splice(index, 1);
    if (mruStore.isInitialized) {
        setFolderMruConfigurationService_1.default(mruStore.mruFolders);
    }
});
//# sourceMappingURL=removeFolderIdFromMoveToMruList.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.MoveMruActions.js